import { render } from "./AddIncome.vue?vue&type=template&id=0dc6f31e"
import script from "./AddIncome.vue?vue&type=script&lang=js"
export * from "./AddIncome.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__